export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "位置", prop: "type", slots: "type" },
    { label: "banner标题", prop: "name" },
    { label: "图片预览", prop: "imgUrl", slots: "imgUrl" },
    { label: "状态", prop: "status", slots: "status" },
    { label: "是否有跳转", prop: "disable", slots: "disable" },
    {
      label: "显示顺序",
      prop: "sort",
      width: 100,
    },
    {
      label: "创建日期",
      prop: "createTime",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 200,
      slots: "operation",
      fixed: "right",
    },
  ];
}
